"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentManagerConfigProvider = /** @class */ (function () {
    function DocumentManagerConfigProvider() {
    }
    DocumentManagerConfigProvider.DOCUMENT_MANAGER_CONFIGS_KEY = 'documentManagerConfigs';
    return DocumentManagerConfigProvider;
}());
exports.DocumentManagerConfigProvider = DocumentManagerConfigProvider;
//# sourceMappingURL=document-manager-config.provider.js.map